import { createContext, useContext } from "react";

export const ThemeContext = createContext({
  theme: [],
  setTheme: () => {},
  fetchTheme: () => {},
  reloadTheme: () => {},
  HideThemeSkeleton: false,
  isUpdatedTheme: false,
  ThemeError: null,
  removeTheme: () => {},
  setHideThemeSkeleton: () => {},
  updateDOMColors: () => {},
});

export const useThemeContext = () => useContext(ThemeContext);
